const state = {
  menssagesTerminalSection: [],
  commandsHistTerminalSection:[],
  countCommandTerminalSection:0
}

const getters = {
  getMessagesTerminalSection: state => state.menssagesTerminalSection,
  getCommandHistTerminalSection: state => {
    return state.commandsHistTerminalSection[state.commandsHistTerminalSection.length-state.countCommandTerminalSection]
  },
  getCountCommandTerminalSection: state => state.countCommandTerminalSection,
}

const actions = {
  addMessageTerminalSection ({ commit }, newMessage) {
    commit('SET_COUNT_TERMINAL_SECTION',0)
    commit('ADD_MESSAGE_TERMINAL_SECTION', newMessage)
  },
  clearMessageTerminalSection({ commit }){
    commit('SET_COUNT_TERMINAL_SECTION',0)
    commit('CLEAR_TERMINAL_SECTION')
  },
  clearCountTerminalSection({ commit }){
    commit('SET_COUNT_TERMINAL_SECTION',0)
  },
  incrementCountTerminalSection({ commit,state }){
    if(state.countCommandTerminalSection<state.commandsHistTerminalSection.length){
      commit('SET_COUNT_TERMINAL_SECTION',state.countCommandTerminalSection+1)
    }
  },
  decrementCountTerminalSection({ commit }){
    if(state.countCommandTerminalSection>0){
      commit('SET_COUNT_TERMINAL_SECTION',state.countCommandTerminalSection-1)
    }
  },
}

const mutations = {
  ADD_MESSAGE_TERMINAL_SECTION: (state, newMessage) => (state.menssagesTerminalSection.push(newMessage)),
  CLEAR_TERMINAL_SECTION: (state) => (state.menssagesTerminalSection = []),
  ADD_CMD_TERMINAL_SECTION: (state, newCommand) => (state.commandsHistTerminalSection.push(newCommand)),
  SET_COUNT_TERMINAL_SECTION: (state, newCount) => (state.countCommandTerminalSection=newCount),
}

export default {
  state,
  getters,
  actions,
  mutations
}
